import React from 'react'
import MainLayout from './MainLayout'


export default function Courses() {
  return (
    <div>
      <MainLayout/>
    </div>
  )
}
